<template>
  <main>
    <!-- <v-data-table :headers="headers" :items="camps" hide-default-footer></v-data-table> -->
    <v-container>
      <!-- Add / Edit Majors -->
      <Form
        @set_edited_major="handleEditMajor"
        @fetchData="fetchData"
        :majors="majors"
        :major_id="major_id"
        :majorObject="majorObject"
        :isEdited="isEdited"
        :loadingDataTable="loadingDataTable"
        v-if="permissions.includes('store_api_admin-panel_camps_{camp}_majors')"
      />
      <section v-for="classification in majors" :key="classification.index">
        <template v-if="classification.majors">
          <h2 class="mb-5 mt-10">{{ classification.name }}</h2>
          <v-data-table
            :headers="headers"
            :loading="loadingDataTable"
            :items="classification.majors"
            :mobile-breakpoint="zero"
            :items-per-page="100"
            hide-default-footer
            class="table teams"
          >
            <template v-slot:item="{ item, index }">
              <tr class="table__row">
                <td class="table__cell text-center">
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.name || '---'"
                    :max-chars="20"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </td>
                <td class="table__cell text-center">
                  {{ item ? item.classification.name : "---" }}
                </td>
                <td class="table__cell text-center">
                  <span>{{ item ? item.min_grade.name : "---" }}</span>
                  <span> - </span>
                  <span>{{ item ? item.max_grade.name : "---" }}</span>
                </td>
                <td class="table__cell text-center">
                  {{ item.min_age + ` - ` + item.max_age + ` Years` }}
                </td>
                <td class="table__cell text-center">
                  {{ item ? item.boys_capacity : "---" }}
                </td>
                <td class="table__cell text-center">
                  {{ item ? item.girls_capacity : "---" }}
                </td>
                <td class="table__cell text-center">
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.description || '---'"
                    :max-chars="20"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </td>

                <td class="table__cell text-center">
                  <span
                    v-if="
                      permissions.includes(
                        'update_api_admin-panel_camps_{camp}_majors_{major}'
                      )
                    "
                    @click="handleEdit(item, index)"
                    class="hovering mr-1 edit"
                  >
                    <v-icon small>mdi-pencil</v-icon><br />
                    Edit
                  </span>
                  <span
                    @click="handleDelete(item, index)"
                    class="hovering delete"
                    v-if="
                      permissions.includes(
                        'destroy_api_admin-panel_camps_{camp}_majors_{major}'
                      )
                    "
                  >
                    <v-icon small>mdi-delete</v-icon><br />
                    Delete
                  </span>
                  <span v-else>---</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </section>
      <!-- {{ majors }} -->
    </v-container>
  </main>
</template>

<script>
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      majors: [],
      panel: [0, 1],
      camp_team: [],
      majorObject: {},
      major_id: 0,
      major_index: "",
      isEdited: false,
      loadingDataTable: false
    };
  },
  components: {
    Form: () => import("./components/Form")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.indexMajors();
    this.createTableHeaders();
  },
  methods: {
    indexMajors() {
      this.loadingDataTable = true;
      IndexData({ reqName: `camps/${this.$route.params.id}/majors` })
        .then(res => {
          const { data } = res.data;
          this.majors = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleEditMajor(team) {
      this.$set(this.majors, this.major_index, team);
      this.isEdited = false;
    },
    handleEdit({ id }, index) {
      this.scrollTop();
      this.major_id = id;
      this.major_index = index;
      this.isEdited = true;
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/camps/${this.$route.params.id}/majors`,
            id: id
          })
            .then(() => {
              this.$delete(this.majors, index);
              this.fetchData();
            })
            .catch(() => {});
        }
      });
    },
    createTableHeaders() {
      const headersList = [
        "Major Name",
        "Classification",
        "Grade",
        "Age",
        "Boys",
        "Girls",
        "Description",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    fetchData() {
      this.indexMajors();
    }
  }
};
</script>
